/**
 * Flexible, reusable stylistic "Button" component
 * Optional props that allow for different semantic html tags,
 * icons, labels, etc
 */

import { h } from "preact";
import { Icon } from ".";
import { ButtonProps } from "../types/buttonTypes";

const Button = (props: ButtonProps) => {
  const {
    className,
    formId,
    id,
    tag,
    label,
    labelHidden,
    title,
    iconType,
    type,
    iconStyle,
    download,
    href,
  } = props;

  const labelStyle = labelHidden ? "srOnly" : "";
  const Element = tag;

  return (
    <Element
      {...(type && { type: type })}
      {...(formId && { form: formId })}
      {...(title && { title: title })}
      id={id}
      data-testid={id}
      class={className}
      {...(download && { download })}
      {...(href && { href: href })}
    >
      {iconType && iconStyle && <Icon type={iconType} style={iconStyle} />}
      <span class={labelStyle}>{label}</span>
    </Element>
  );
};

export default Button;
